<div class="chip-select" [class.chip-select--disabled]="disabled()">
  @for (option of options(); track option.value) {
    <button
      type="button"
      class="chip-select__chip"
      [class.chip-select__chip--selected]="isSelected(option)"
      [class.chip-select__chip--muted]="option.muted"
      [attr.aria-pressed]="isSelected(option)"
      [disabled]="disabled()"
      (click)="toggle(option)"
    >
      @if (multiple() && isSelected(option)) {
        <span class="material-icons chip-select__check" aria-hidden="true">check</span>
      }
      {{ option.label | translate }}
    </button>
  }

  @for (value of customValues(); track value) {
    <button
      type="button"
      class="chip-select__chip chip-select__chip--selected"
      [attr.aria-label]="('ChipSelect.remove' | translate) + ': ' + getCustomText(value)"
      [title]="'ChipSelect.remove' | translate"
      [disabled]="disabled()"
      (click)="removeCustom(value)"
    >
      {{ getCustomText(value) }}
      <span class="material-icons chip-select__remove" aria-hidden="true">close</span>
    </button>
  }

  @if (canAddCustom()) {
    @if (editingCustom()) {
      <span class="chip-select__custom" [class.chip-select__custom--wide]="customWide()">
        <input
          #customInput
          type="text"
          class="chip-select__custom-input"
          [placeholder]="customPlaceholder() | translate"
          [maxLength]="customMaxLength()"
          [attr.inputmode]="customInputMode()"
          (keydown.enter)="$event.preventDefault(); confirmCustom()"
          (keydown.escape)="cancelCustom()"
        />
        <button type="button" class="chip-select__chip chip-select__chip--selected" (click)="confirmCustom()">
          {{ 'ChipSelect.confirm' | translate }}
        </button>
      </span>
    } @else {
      <button
        type="button"
        class="chip-select__chip chip-select__chip--add"
        [disabled]="disabled()"
        (click)="startCustom()"
      >
        {{ customLabel() | translate }}
      </button>
    }
  }
</div>
